module.exports = __webpack_public_path__ + "arrow-left.png?2257d208e2577c8dd47570d6f2f19333";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-left.png
// module id = 642
// module chunks = 0 2 7 8 9 10 11 16